$w.onReady(function () {});

let flyOptions = {
  "duration":   200,
  "delay":      0,
  "direction":  "top"
};

export function Header_viewportEnter(event) {
	$w("#box3").hide();
	$w("#image29").hide();
	$w("#box4").hide();
	}

export function anchor_viewportEnter(event) {
	$w("#box3").hide();
	$w("#image29").hide();
	$w("#box4").hide();
}

export function anchor_viewportLeave(event) {
	$w("#box3").show("float", flyOptions);
	$w("#image29").show("float", flyOptions);
	$w("#box4").show();
}